import styled from "@emotion/styled";
import { color } from "metabase/lib/colors";
export const LoginTitle = styled.div`
  color: ${color("text-dark")};
  font-size: 1.25rem;
  font-weight: 700;
  line-height: 1.5rem;
  text-align: center;
`;
export const LoginPanel = styled.div`
  margin-top: 2.5rem;
`;
export const ActionList = styled.div`
  margin-top: 3.5rem;
`;
export const ActionListItem = styled.div`
  margin-top: 2rem;
  text-align: center;
`;
